import { tracking } from '@iwoca/frontend-tracking-library';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export type TFeedbackCategory =
    | 'doc_requirement_reviews'
    | 'additional_info_requests'
    | 'account_file_feedback';

export const MarkDoneButton = ({
    isMarkedAsDone,
    isLoading,
    onClick,
    feedbackCategory
}: {
    isMarkedAsDone: boolean;
    isLoading: boolean;
    onClick: () => void;
    feedbackCategory: TFeedbackCategory;
}) => {
    const handleClick = () => {
        tracking.ampli.markAsDoneClicked({
            document_feedback_category: feedbackCategory,
            marked_as_done_by_customer: !isMarkedAsDone
        });

        onClick();
    };

    return (
        <>
            {isMarkedAsDone ? (
                <Button
                    variant="tertiary"
                    className="!text-success-drk disabled:!text-transparent"
                    onClick={handleClick}
                    loading={isLoading}
                >
                    <FormattedMessage
                        id="_.trading_data.document_feedback.marked_as_done"
                        defaultMessage="Marked as done"
                    />
                </Button>
            ) : (
                <Button
                    variant="tertiary"
                    onClick={handleClick}
                    loading={isLoading}
                >
                    <FormattedMessage
                        id="_.trading_data.document_feedback.mark_as_done"
                        defaultMessage="Mark as done"
                    />
                </Button>
            )}
        </>
    );
};
